import React from 'react';
import { RequirePermissions, Permissions } from '@/core/permissions/export';
import PipelineNotificationsPanel from '@/modules/pipelines/components/deep-dive/notifications/pipeline-notifications-panel';

export default function PipelinePlusRoute({ children }: React.PropsWithChildren) {
  return (
    <RequirePermissions
      allow={Permissions.PETRO_PIPELINES_PLUS}
      fallback={<PipelineNotificationsPanel />}
    >
      {children}
    </RequirePermissions>
  );
}
